<template>
  <nav aria-label="breadcrumb">
    <ol class="m-0 flex list-none flex-wrap p-0">
      <li
        v-for="(crumb, index) in breadcrumbs"
        :key="index"
        class="flex items-center font-medium overflow-hidden"
      >
        <template v-if="index < breadcrumbs.length - 1">
          <router-link
            :to="crumb.path"
            class="text-primary transition-colors hover:underline underline-offset-4"
          >
            {{ crumb.name }}
          </router-link>
          <IconChevronRight class="mx-2 size-4" />
        </template>
        <template v-else>
          <span class="font-bold text-blue min-w-0 max-w-[400px] truncate">
            {{ crumb.name }}
          </span>
        </template>
      </li>
    </ol>
  </nav>
</template>

<script setup>
import { IconChevronRight } from '@tabler/icons-vue'

const props = defineProps({
  breadcrumbs: {
    type: Array,
    required: true,
  },
})
</script>
